export const MESSAGER_LOCALE_ZHCHT = {
    yes: 'æ¯',
    no: 'å¦',
    ok: 'ç¢ºå®',
    cancel: 'åæ¶',
    title: 'ä¿çµ±æç¤º',
    errorTitle: 'é¯èª¤æç¤º',
    prompt: {
        fontSize: {
            name:  'å­é«å¤§å°',
            small: 'å°',
            middle: 'ä¸­',
            big: 'å¤§',
            large: 'ç¹å¤§',
            huge: 'è¶å¤§'
        }
    },
    exception: {
        expand: 'å±é',
        collapse: 'æ¶èµ·',
        happend: 'ç¼çæé',
        detail: 'è©³ç´°ä¿¡æ¯',
        copy: 'è¤å¶è©³ç´°ä¿¡æ¯',
        copySuccess: 'è¤å¶æå',
        copyFailed: 'è¤å¶å¤±æ',
        roger: 'ç¥éäº'
    }
};
